import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductsPromptModalState, SetProductsPromptModalStatePayload } from './types';

const INITIAL_STATE: ProductsPromptModalState = {
  visible: false,
};

const productsPromptModalSlice = createSlice({
  name: 'productsPromptModal',
  initialState: INITIAL_STATE,
  reducers: {
    setProductsPromptModalState: (state, { payload }: PayloadAction<SetProductsPromptModalStatePayload>) => {
      const dismissButtonLabel = payload ? payload.dismissButtonLabel || 'Dismiss' : state.dismissButtonLabel;
      const resetQueryParamsOnDismiss = payload
        ? payload.resetQueryParamsOnDismiss ?? true
        : state.resetQueryParamsOnDismiss;
      return {
        ...(payload || state),
        dismissButtonLabel,
        resetQueryParamsOnDismiss,
        visible: !!payload,
      };
    },
  },
});

export default productsPromptModalSlice;
